import { render, staticRenderFns } from "./ImgRankinP2.vue?vue&type=template&id=3f92437f"
import script from "./ImgRankinP2.vue?vue&type=script&lang=js"
export * from "./ImgRankinP2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports